<mat-icon
  class="mat-error-icon"
  [matMenuTriggerFor]="fixPhoneInstructions"
  #fixPhoneInstructionsTrigger="matMenuTrigger"
  >error</mat-icon
  >
  <mat-menu #fixPhoneInstructions="matMenu" class="instructions-menu">
    <div>{{ fixPhoneInstructionsString }}</div>
    @if (!onlyDisplayInstructions) {
      <br />
    }

    @if (issuesLabel !== null && !onlyDisplayInstructions) {
      <div>{{ issuesLabel }}</div>
    }
    @if (!onlyDisplayInstructions) {
      <br />
    }
    @if (issuesPhonesArray.length > 0 && !onlyDisplayInstructions) {
      <div class="issues-phones-list-or-extension">
        @for (phone of issuesPhonesArray; track phone; let i = $index) {
          <div>
            <div>
              {{ phone.phoneType }}:
              @if (phone.deviceTypeId) {
                <span>{{ phone.deviceTypeId }}</span>
              }
              @if (phone.phoneType === 'Hardphone') {
                <span> with MAC address {{ phone.macAddressOrSipUsername }}</span>
              }
              @if (phone.phoneType === 'Softphone') {
                <span> {{ phone.macAddressOrSipUsername }}</span>
              }
            </div>
            @if (i < issuesPhonesArray.length - 1) {
              <br />
            }
          </div>
        }
      </div>
    }
    @if (issueExtension !== null && !onlyDisplayInstructions) {
      <div class="issues-phones-list-or-extension">
        {{ issueExtension }}</div
        >
      }
    </mat-menu>
